export enum UnitOfTime {
    Minute = 0,
    Hour = 1, 
    Day = 2
}